import { render, staticRenderFns } from "./CheckBoxs.vue?vue&type=template&id=fa0ea690&"
import script from "./CheckBoxs.vue?vue&type=script&lang=js&"
export * from "./CheckBoxs.vue?vue&type=script&lang=js&"
import style0 from "./CheckBoxs.vue?vue&type=style&index=0&id=fa0ea690&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports